import { computed, Ref } from 'vue'

import { BetStatus, Event } from '@collector/sportsapi-client-legacy'

import { BetMarketEventKey } from './types.js'

export type UseBetMarketStatus = { isBetMarketActive: Ref<boolean> }

export function useBetMarketStatus(
  event: Ref<Event>,
  key: BetMarketEventKey,
): UseBetMarketStatus {
  const isBetMarketActive = computed(() =>
    [BetStatus.Active, BetStatus.EarlySuspended].includes(event.value[key]),
  )

  return { isBetMarketActive }
}
